import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShowVisible = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.34608 8.03266C5.83535 6.16335 8.28216 4.25 12 4.25C15.7178 4.25 18.1647 6.16335 19.6539 8.03266C20.3962 8.96436 20.9083 9.89252 21.2351 10.5868C21.786 11.7572 21.7946 12.2245 21.2351 13.4132C20.9083 14.1075 20.3962 15.0356 19.6539 15.9673C18.1647 17.8367 15.7178 19.75 12 19.75C8.28216 19.75 5.83535 17.8367 4.34608 15.9673C3.60379 15.0356 3.09172 14.1075 2.76492 13.4132C2.22725 12.2709 2.22725 11.7291 2.76492 10.5868C3.09172 9.89252 3.60379 8.96436 4.34608 8.03266ZM18.4807 8.96734C19.1327 9.78564 19.5869 10.6075 19.8779 11.2257C20.1941 11.8974 20.1941 12.1026 19.8779 12.7743C19.5869 13.3925 19.1327 14.2144 18.4807 15.0327C17.1816 16.6633 15.1284 18.25 12 18.25C8.87162 18.25 6.81843 16.6633 5.51927 15.0327C4.86732 14.2144 4.41306 13.3925 4.12209 12.7743C3.80589 12.1026 3.80589 11.8974 4.12209 11.2257C4.41306 10.6075 4.86732 9.78564 5.51927 8.96734C6.81843 7.33665 8.87162 5.75 12 5.75C15.1284 5.75 17.1816 7.33665 18.4807 8.96734Z",
		fill: "currentColor"
	})]
});
export { SvgIconShowVisible as ReactComponent };
